export default [{ Code: 1, DisplayName: "No Phones" },
{ Code: 2, DisplayName: "Phones Where Available" },
{ Code: 3, DisplayName: "Only Records With Phones" }]


// WEBPACK FOOTER //
// ./src/config/PhoneOptions.js